import { Modal, SystemText, Table } from '@salesperformanceint/e4shared';
import { skillColour } from 'helpers/metrics';
import { translateSkill } from 'helpers/translations';
import React from 'react';
import { useSelector } from 'react-redux';

export const QuickCheckSkills = ({ show, close }) => {
    const [skills, setSkills] = React.useState([]);
    const [questions, setQuestions] = React.useState([]);
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        if (show?.skills) {
            setSkills(
                show.skills
                    .map(s => translateSkill(user.language_Code.toLowerCase(), s))
                    .map(s => ({
                        skill: s.title,
                        baseline: s.scores.baseline,
                        current: s.scores.current,
                        final: s.scores.final,
                    }))
            );
        } else {
            setSkills([]);
        }

        setQuestions([
            {
                total: show.totalQuestions || '-',
                inProgress: show.questionsInProgress || '-',
                retired: show.questionsRetired || '-',
                mastered: show.questionsMastered || '-',
            },
        ]);
    }, [show]);

    let skillColumns = [
        {
            label: SystemText('LearningTracker/QuickCheck/Results/Table/Skill'),
            className: 'prism-test-result',
            dataProperty: 'skill',
        },
        {
            label: SystemText('LearningTracker/QuickCheck/Results/Table/Baseline'),
            dataProperty: 'baseline',
            className: 'text-center prism-test-result',
            format: x => <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label>,
        },
        {
            label: SystemText('LearningTracker/QuickCheck/Results/Table/Current'),
            dataProperty: 'current',
            className: 'text-center prism-test-result',
            format: x => <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label>,
        },
        {
            label: SystemText('LearningTracker/QuickCheck/Results/Table/Final'),
            dataProperty: 'final',
            className: 'text-center prism-test-result',
            format: x =>
                x ? <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label> : <div>-</div>,
        },
    ];

    let questionColumns = [
        {
            label: SystemText('LearningTracker/QuickCheck/QuestionsTotal'),
            className: 'prism-test-result',
            dataProperty: 'total',
        },
        {
            label: SystemText('LearningTracker/QuickCheck/QuestionsInProgress'),
            className: 'prism-test-result',
            dataProperty: 'inProgress',
        },
        {
            label: SystemText('LearningTracker/QuickCheck/QuestionsRetired'),
            className: 'prism-test-result',
            dataProperty: 'retired',
        },
        {
            label: SystemText('LearningTracker/QuickCheck/QuestionsMastered'),
            className: 'prism-test-result',
            dataProperty: 'mastered',
        },
    ];

    const skillOptions = {
        hidePaging: true,
        tableClass: 'table table-striped',
        sortBy: null,
        ascending: null,
    };

    const questionOptions = {
        hidePaging: true,
        tableClass: 'table table-striped',
        sortBy: null,
        ascending: null,
    };

    return (
        <Modal show={show} title={show.title} close={close} footer={null}>
            <Table data={questions} columns={questionColumns} options={questionOptions} />
            <Table data={skills} columns={skillColumns} options={skillOptions} />
        </Modal>
    );
};

export default QuickCheckSkills;
